import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {ApplicationModel} from '../../../../../../../models/api/applicationModel';

/*
 * Props.
 */

interface CommentViewerReferencePreviewerUnfurlIconProps {
  application?: ApplicationModel;
  isAnnotationCard?: boolean;
}

/*
 * Style.
 */

const StyledApplicationImg = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 9000px;
  overflow: hidden;
`;

/*
 * Component.
 */

export const CommentViewerReferencePreviewerUnfurlIcon: FC<CommentViewerReferencePreviewerUnfurlIconProps> = (
  props,
) => {
  const {application, isAnnotationCard} = props;
  const theme = useUserTheme();

  // If we do not have an application or the applications doesn't have an icon.
  if (!application || !application.iconUrl) {
    if (isAnnotationCard) {
      return <Icon name="formattingLink" color={theme.greys.shade60} />;
    }
    return <Icon name="topicWebSmall" color={theme.greys.shade60} size={14} />;
  }
  return <StyledApplicationImg src={application.iconUrl} />;
};
